import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

import Home from "@/pages/Home";
import Raffles from "@/pages/Raffles";
import RaffleDetail from "@/pages/RaffleDetail";
import Shop from "@/pages/Shop";
import JerseyDetail from "@/pages/JerseyDetail";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRaffles from "@/pages/AdminRaffles";
import AdminJerseys from "@/pages/AdminJerseys";
import AdminAddOns from "@/pages/AdminAddOns";
import AdminOrders from "@/pages/AdminOrders";

function PublicLayout() {
  return (
    <>
      <Header />
      <main className="min-h-[calc(100vh-200px)]"><Outlet /></main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#1C1816",
              border: "1px solid #332D2B",
              color: "#F2EBDD",
              borderRadius: "0",
              fontFamily: "Chivo, sans-serif",
            },
          }}
        />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/raffles" element={<Raffles />} />
            <Route path="/raffles/:id" element={<RaffleDetail />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:id" element={<JerseyDetail />} />
            <Route path="/order/:reference" element={<OrderConfirmation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="raffles" element={<AdminRaffles />} />
              <Route path="jerseys" element={<AdminJerseys />} />
              <Route path="addons" element={<AdminAddOns />} />
              <Route path="orders" element={<AdminOrders />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
